import React from 'react'

const Animation = () => {
    return (
        <div className='white'>
            <div className='squares'>
                <div className='square'></div>
                <div className='square'></div>
                <div className='square'></div>
                <div className='square'></div>
                <div className='square'></div>
                <div className='square'></div>
                <div className='square'></div>
                <div className='square'></div>
                <div className='square'></div>
                <div className='square'></div>
            </div>
        <div className='grey'></div>
    </div>
    )
}

export default Animation;